/* ========= CUSTOM JS by LU ========== */
/* ==================================== */

document.addEventListener("DOMContentLoaded", function() {

    /* Form di contatto in Homepage */
    const section = document.getElementById('shopify-section-template--26936928305490__17609725760d19972e')

    if (section) {
        const button = document.querySelector('#shopify-section-template--26936928305490__rich_text_dUGHUE a.button')
        button.setAttribute("aria-label", "Apri il form di contatto");

        button.addEventListener('click', function(e) {
            e.preventDefault()
            section.classList.add('active')
            
            const bgDiv = document.createElement('div');
            bgDiv.setAttribute("id", "bgCustom");
            section.insertAdjacentElement('afterend', bgDiv);
            bgDiv.addEventListener('click', closeForm);

            const close = document.createElement('button');
            close.setAttribute("id", "closeFormButton");
            close.setAttribute("aria-label", "Chiudi il form di contatto");
            close.innerHTML = '<span></span><span></span>';
            section.appendChild(close);
            close.addEventListener('click', closeForm);

            function closeForm() {
                section.classList.remove('active')
                bgDiv.removeEventListener('click', closeForm)
                close.removeEventListener('click', closeForm)
                bgDiv.remove()
                close.remove()
            }
        })
    }
})